import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

import { useLocation, useNavigate } from "react-router-dom";


import Loading from "components/Loading";
import TablePaginationActions from "layouts/category/components/TablePagination";
import { useGetAllProviderQuery } from "App/services/providerServiceApi";
import { useDeleteProviderMutation } from "App/services/providerServiceApi";
import ProviderFormDialog from "./components/providerFormDialog";
import ProviderEditFormDialog from "./components/providerEditFormDialog";


function Provider() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  // const {data: categories, isError, isLoading, isFetching, error } = useGetSearchCategoryQuery(data.data);

  const {
    data: providers,
    isLoading,
    isFetching,
    isError,
    error,
  } = useGetAllProviderQuery({
    refetchOnFocus: false,
  });

  const [deleteProvider] = useDeleteProviderMutation();

  if (isLoading || isFetching) {
    return <Loading />;
  }

  // if (isError) {

  //   return <NotFound error={error} />;
  // }


  // Delete Botton and Delete Dialog Box work

  const handleDeleteProvider = async () => {
    try {
      await deleteProvider(deleteId);
      setDeleteDialogOpen(false);
      setDeleteId(null);
      if (providers.length === 1) {
        window.location.reload(); 
      } else {
        refetchProviders();
      }

    } catch (error) {

      console.error("Failed to delete provider:", error);
    }
  };


  const handleDeleteConfirmation = (providerId) => {
    setDeleteId(providerId);
    setDeleteDialogOpen(true);
  };



  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };


     // Category Id navigate to SubCategory

  const handleNavigateAds = async (providerId) => {

    navigate('/ads', { state: { data: providerId } });
  }


      // Pagination System
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (providers ?
// check any Category  
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info" 
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Provider
                </MDTypography>
                <ProviderFormDialog />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead >
                    <TableRow >
                      <TableCell>Provider Name</TableCell>
                      <TableCell sx={{textAlign:'left', paddingRight:20}}>status</TableCell>
                      <TableCell sx={{textAlign:'right', paddingRight:20}}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? providers && providers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : providers
                    ).map((provider) => (
                      <TableRow key={provider.id} >
                        <TableCell sx={{ textAlign: 'left', textDecorationLine:'underline', cursor:'pointer','&:hover': {color: 'blue'} }} onClick={() => handleNavigateAds(provider.id)}>{provider.name}</TableCell>
                        <TableCell sx={{ textAlign: 'left' }}>{provider.adStatus === 0 ? "InActive" : "Active"}</TableCell>
                        
                        
                        <TableCell sx={{textAlign:'right', paddingRight:17}}>
                          <Tooltip title="Edit">
                            <IconButton aria-label="edit">
                              <ProviderEditFormDialog provider={provider} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton aria-label="delete" onClick={() => handleDeleteConfirmation(provider.id)} >
                              <Icon>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                   {/* pagination */}

                  <TableFooter>
                    <TableRow  >
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={providers.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

       {/* Delete Dialog Box Open */}

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        sx={{textAlign:'center'}}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Are you sure you want to delete this Provider and its related all Ads Deleted
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteProvider} style={{ color: 'red' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
    :

      // not Available any Category show only Head components 

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}  
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Provider
                </MDTypography>
                <ProviderFormDialog />

              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead >
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  </Table>
                  </TableContainer>
                  </Card>
                  </Grid>
                  </Grid>
                  </MDBox>
                  </DashboardLayout>
                  
  );
}

export default Provider;
